'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../../utils/getThemeProp.js');
var OutlinedInput = _interopDefault(require('@material-ui/core/OutlinedInput'));
var highlight = require('../utils/highlight.js');

var StyledInput = styled__default(OutlinedInput)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  border-radius: 6px;\n  background-color: ", ";\n\n  .MuiInputBase-input {\n    border-radius: 6px;\n    position: relative;\n    padding: 6px 28px 6px 13px;\n    max-width: 100%;\n    min-height: 24px;\n  }\n\n  &.MuiOutlinedInput-root {\n    ", "\n  }\n"], ["\n  border-radius: 6px;\n  background-color: ", ";\n\n  .MuiInputBase-input {\n    border-radius: 6px;\n    position: relative;\n    padding: 6px 28px 6px 13px;\n    max-width: 100%;\n    min-height: 24px;\n  }\n\n  &.MuiOutlinedInput-root {\n    ", "\n  }\n"])), getThemeProp('palette.background.paper', 'white'), highlight.outlinedContent);
var templateObject_1;

exports.StyledInput = StyledInput;
